package ui.screens.section.brideandgroom

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ui.screens.section.brideandgroom.composable.BrideSection
import ui.screens.section.brideandgroom.composable.GroomSection

@Composable
fun BrideAndGroomSection(
    textColor: Color,
    imageHeight: Dp,
    imageWidth: Dp,
    decorationSize: Dp,
    decorationSizeX2: Dp,
    safeEntered: Boolean,
) {
    Column {
        BrideSection(
            textColor,
            imageHeight,
            imageWidth,
            decorationSize,
            decorationSizeX2,
            safeEntered
        )
        Text(
            "&",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 90.dp, bottom = 90.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleLarge.copy(
                fontWeight = FontWeight.SemiBold,
                fontSize = 80.sp,
            ),
            color = textColor,
        )
        GroomSection(
            textColor,
            imageHeight,
            imageWidth,
            decorationSize,
            safeEntered
        )
    }
}

val cutoutShape
    get() = RoundedCornerShape(
        topStartPercent = 80,
        topEndPercent = 80,
        bottomStartPercent = 5,
        bottomEndPercent = 5
    )